import './main.component.scss';
import '@splidejs/splide/css/core';
import {HttpService} from "../../../services/http.service.js";
import {config} from "../../../config.js";
import {Splide} from '@splidejs/splide';
import {AutoScroll} from '@splidejs/splide-extension-auto-scroll';
import {splitArray} from "../../../utils/split-array.js";
import {horizontalResize} from "../../../utils/horizontal-resize.js";
import {MenuComponent} from "../../shared/menu/menu.component.js";
import {FeedbackComponent} from "../../shared/feedback/feedback.component.js";
import {setInfoToLinks} from "../../../utils/setInfoToLinks.js";

export class MainComponent {
    config = config;
    httpService = HttpService;

    directionsPath = this.config.directoryPaths.staticImagePath + this.config.directoryPaths.directions + '/';
    directionsListElement = document.getElementById('directions-list');
    directionsWorkData = null;

    servicesPath = this.config.directoryPaths.staticImagePath + this.config.directoryPaths.services + '/';
    servicesMobilePath = this.config.directoryPaths.staticImagePath + this.config.directoryPaths.servicesMobile + '/';
    servicesSection = document.getElementById('services');
    servicesListElement = document.getElementById('services-list');
    servicesData = null;

    companiesPath = this.config.directoryPaths.staticImagePath + this.config.directoryPaths.companiesLogo + '/';
    companiesListTopElement = document.getElementById('companies-top');
    companiesListBottomElement = document.getElementById('companies-bottom');
    companiesData = null;

    telegramKafedraLinks = document.querySelectorAll('[data-telegram-kafedra-link]')

    isMobileScreen = window.screen.width <= 768;

    constructor() {
        this.setConfigInfo();
        this.renderDirections().then();
        this.renderServices().then();
        this.getCompaniesLogo().then(() => {
            this.renderCompaniesLogo();
            this.sliderCompaniesLogoInit();
        });

        // закрываем мобюменю и фидбэк при горизонтальном ресайзе
        horizontalResize(() => {
            MenuComponent.closeBurgerMenu();
            FeedbackComponent.closeFeedback();
        });

        document.addEventListener("click", (eve) => {
            const {target} = eve;

            // скролл до списка услуг по клику на кнопку (подробнее об услугах)
            if (target.matches('[data-show-services]')) {
                this.servicesSection.scrollIntoView({behavior: 'smooth'});
            }
        })

    }

    setConfigInfo() {
        // Присваиваем телеграм кафетры для всех нужных ссылок
        setInfoToLinks(this.telegramKafedraLinks, config.telegramKafedra)
    }

    // Получение и отрисовка направления работ
    async renderDirections() {
        this.directionsWorkData = await this.httpService.get(this.config.dataBase.directionsWork);

        if (!this.directionsWorkData || this.directionsWorkData.length < 1) {
            document.getElementById('directions').style.display = 'none';
            console.error("Не удалось получить направления работ");
        }

        if (this.directionsListElement) {
            this.directionsWorkData.forEach(item => {
                this.directionsListElement.insertAdjacentHTML('beforeend', `
                 <li class="direction-card">
                    <h4 class="direction-card__title">${item.title}</h4>
                    <div class="direction-card__image">
                        <img src="${this.directionsPath + item.image}" 
                        width="180"
                        height="180"
                        loading="lazy"
                        alt="${item.title}">
                    </div>
                </li>
            `);
            });
        } else {
            console.error("Не удалось получить DOM-элемент по id='directions'");
        }

    }

    // Получение и отрисовка Услуг
    async renderServices() {
        this.servicesData = await this.httpService.get(this.config.dataBase.services);
        if (!this.servicesData || this.servicesData.length < 1) {
            document.getElementById('services').style.display = 'none';
            console.error("Не удалось получить услуги");
        }

        if (this.servicesListElement) {
            this.servicesData.forEach(item => {

                let imageBlockHtml = (!!item.image) ? `
                                        <div class="service-card__image">
                                            <picture>
                                                <source media="(max-width: 768px)"
                                                        width="60" height="60"
                                                        srcset="${this.servicesMobilePath + item.image}">
                                                
                                                <!-- Десктопная версия (по умолчанию) -->
                                                <img src="${this.servicesPath + item.image}" alt="${item.title}" 
                                                     width="120" height="100" 
                                                     alt="${item.title}">
                                            </picture>
                                      </div>` : '';

                let linkHtml = (!!item.url) ? `<a href="${item.url}" target="_blank" class="service-card__text-link button">
                                    <svg width="15" height="13" viewBox="0 0 15 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M8.36278 0.244063C8.69909 -0.0808196 9.20987 -0.078643 9.54337 0.23439L9.60762 0.300891L15 6.49997L9.60762 12.699C9.27877 13.077 8.72147 13.1024 8.36278 12.7559C8.00415 12.4093 7.98005 11.822 8.30886 11.444L11.8013 7.42856H0.881138C0.394499 7.42856 0 7.01281 0 6.49997C0 5.98712 0.394499 5.57137 0.881138 5.57137H11.8013L8.30886 1.55594L8.25149 1.48219C7.98466 1.10493 8.02661 0.568915 8.36278 0.244063Z"
                                              fill="#252525"/>
                                    </svg>
                                    <span>Смотреть кейсы</span>
                                    <svg width="15" height="13" viewBox="0 0 15 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M8.36278 0.244063C8.69909 -0.0808196 9.20987 -0.078643 9.54337 0.23439L9.60762 0.300891L15 6.49997L9.60762 12.699C9.27877 13.077 8.72147 13.1024 8.36278 12.7559C8.00415 12.4093 7.98005 11.822 8.30886 11.444L11.8013 7.42856H0.881138C0.394499 7.42856 0 7.01281 0 6.49997C0 5.98712 0.394499 5.57137 0.881138 5.57137H11.8013L8.30886 1.55594L8.25149 1.48219C7.98466 1.10493 8.02661 0.568915 8.36278 0.244063Z"
                                              fill="#252525"/>
                                    </svg>
                                </a>` : '';

                this.servicesListElement.insertAdjacentHTML('beforeend', `
                        <li class="service-card">
                            <h4 class="service-card__title">${item.title}</h4>
                            ${imageBlockHtml}
                            <div class="service-card__text">
                                <p class="service-card__text-p">${item.text}</p>
                                ${linkHtml}
                            </div>
                        </li>
                `);

            });
        } else {
            console.error("Не удалось получить DOM-элемент по id='services-list'");
        }

    }

    // Получение и отрисовка логотипов компаний "нам доверяют"
    async getCompaniesLogo() {
        this.companiesData = await this.httpService.get(this.config.dataBase.companiesLogo);

        if (!this.companiesData || this.companiesData.length < 1) {
            document.getElementById('trust-us').style.display = 'none';
            console.error("Не удалось получить логотипы компаний 'Нам доверяют'");
        }

    }

    // рендер логотипов компаний для слайдера-автоскролл для мобилки 2 полосы для десктоп 1 полоса
    renderCompaniesLogo() {
        if (this.isMobileScreen) {

            const [firstHalf, secondHalf] = splitArray(this.companiesData);

            if (this.companiesListTopElement && this.companiesListBottomElement) {
                firstHalf.forEach(item => {
                    this.companiesListTopElement.insertAdjacentHTML('beforeend', `
                        <li class="trust-us__company-list-item splide__slide">
                            <img width="250" height="150" src="${this.companiesPath + item.image}" alt="${item.title}">
                        </li>
                    `);
                });

                secondHalf.forEach(item => {
                    this.companiesListBottomElement.insertAdjacentHTML('beforeend', `
                        <li class="trust-us__company-list-item splide__slide">
                            <img width="250" height="150" src="${this.companiesPath + item.image}" alt="${item.title}">
                        </li>
                    `);
                });
            }

        } else {

            if (this.companiesListTopElement) {
                this.companiesData.forEach(item => {
                    this.companiesListTopElement.insertAdjacentHTML('beforeend', `
                        <li class="trust-us__company-list-item splide__slide">
                            <img width="250" height="150" 
                            loading="lazy"
                            src="${this.companiesPath + item.image}" alt="${item.title}">
                        </li>
                    `);
                });
            }

        }
    }

    // Слайдер-автоскролл логотипов компаний "нам доверяют"
    sliderCompaniesLogoInit() {
        const baseOptions = {
            type: 'loop',
            arrows: false,
            pagination: false,
            autoWidth: true,
            lazyLoad: true,
            autoScroll: {
                speed: 1,
            },
            breakpoints: {
                768: {
                    gap: 12,
                }
            }
        };

        const topSlider = new Splide('.trust-us__inner-top.splide', baseOptions);
        const bottomSlider = new Splide('.trust-us__inner-bottom.splide', {
            ...baseOptions,
            autoScroll: {speed: -0.9}
        });

        [topSlider, bottomSlider].forEach(slider => slider.mount({AutoScroll}));
    }

}
